import { EditPeriodicCheckOutDto, EditPeriodicCheckInDto } from '../../../types/periodic-check.dto'

export const EDIT_PERIODIC_CHECK = 'EDIT_PERIODIC_CHECK'
export const EDIT_PERIODIC_CHECK_SUCCESS = 'EDIT_PERIODIC_CHECK_SUCCESS'
export const EDIT_PERIODIC_CHECK_ERROR = 'EDIT_PERIODIC_CHECK_ERROR'
export const RESET_EDIT_PERIODIC_CHECK = 'RESET_EDIT_PERIODIC_CHECK'

export interface EditPeriodicCheck {
  type: typeof EDIT_PERIODIC_CHECK
  payload: EditPeriodicCheckOutDto<any>
}

export interface EditPeriodicCheckSuccess {
  type: typeof EDIT_PERIODIC_CHECK_SUCCESS
  payload: EditPeriodicCheckInDto<any>
}

export interface EditPeriodicCheckError {
  type: typeof EDIT_PERIODIC_CHECK_ERROR
  payload: string | boolean
}

export interface ResetEditPeriodicCheck {
  type: typeof RESET_EDIT_PERIODIC_CHECK
  payload: null
}
export interface State {
  data: EditPeriodicCheckInDto<any> | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = EditPeriodicCheck | EditPeriodicCheckSuccess | EditPeriodicCheckError | ResetEditPeriodicCheck
